import React, { useState } from "react";
import { Terminal, Copy, Check, FileJson } from "lucide-react";

/* ===================== STYLES ===================== */
import styles from "./ResponseBox.module.scss";

export default function ResponseBox({ response }) {
  const [copied, setCopied] = useState(false);

  /* =========================
     HANDLERS
  ========================= */
  const handleCopy = async () => {
    if (!response) return;

    try {
      const jsonString = JSON.stringify(response, null, 2);
      await navigator.clipboard.writeText(jsonString);
      setCopied(true);

      // Reset the copied state after 2 seconds
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error("Failed to copy response to clipboard", err);
    }
  };

  /* =========================
     JSX
  ========================= */
  return (
    <div className={styles["admin-res-box__card"]}>
      {/* HEADER */}
      <div className={styles["admin-res-box__header"]}>
        <h3 className={styles["admin-res-box__title"]}>
          <Terminal size={18} strokeWidth={2.5} />
          Response Output
        </h3>

        {/* COPY BUTTON (Only shows if there is a response) */}
        {response && (
          <button
            className={`${styles["admin-res-box__copy-btn"]} ${
              copied ? styles["admin-res-box__copy-btn--copied"] : ""
            }`}
            onClick={handleCopy}
            title="Copy JSON"
          >
            {copied ? (
              <>
                <Check size={14} strokeWidth={3} />
                Copied!
              </>
            ) : (
              <>
                <Copy size={14} strokeWidth={2.5} />
                Copy
              </>
            )}
          </button>
        )}
      </div>

      {/* CONTENT AREA */}
      <div className={styles["admin-res-box__content"]}>
        {!response ? (
          <div className={styles["admin-res-box__empty"]}>
            <FileJson size={32} strokeWidth={1.5} opacity={0.5} />
            <p>Awaiting API response...</p>
          </div>
        ) : (
          <pre className={styles["admin-res-box__pre"]}>
            {JSON.stringify(response, null, 2)}
          </pre>
        )}
      </div>
    </div>
  );
}
